import { render, staticRenderFns } from "./UsersViewPage.vue?vue&type=template&id=41c0f6d8"
import script from "./UsersViewPage.vue?vue&type=script&lang=js"
export * from "./UsersViewPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports